var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "#fffffff5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.15 1.21997H4.17997C2.74955 1.21997 1.58997 2.37955 1.58997 3.80997V28.2C1.58997 29.6304 2.74955 30.79 4.17997 30.79H43.15C44.5804 30.79 45.74 29.6304 45.74 28.2V3.80997C45.74 2.37955 44.5804 1.21997 43.15 1.21997Z",
    stroke: "#2E63EE",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52997 2.34985L20.56 16.8099C22.37 18.2599 24.96 18.2599 26.77 16.8099L44.67 2.45985",
    stroke: "#2E63EE",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 13.77L1.58997 26.36",
    stroke: "#2E63EE",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7399 26.36L30.5599 13.77",
    stroke: "#2E63EE",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.67 14.67C24.5371 14.67 25.24 13.9671 25.24 13.1C25.24 12.2329 24.5371 11.53 23.67 11.53C22.8029 11.53 22.1 12.2329 22.1 13.1C22.1 13.9671 22.8029 14.67 23.67 14.67Z",
    fill: "#00C9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitFooter);
export default __webpack_public_path__ + "static/media/submit_footer.d117e3150259baa2fcca38e6ba477754.svg";
export { ForwardRef as ReactComponent };